import { ListingRequest } from './listing.types';
import { generateTodayDate } from './utils';

export enum ListingQueryParams {
  teleMedicineFlg = 'teleMedicineFlg',
  acceptingNewPatientsOnly = 'acceptingNewPatientsOnly',
  languages = 'language',
  zip = 'zip',
  gender = 'gender',
  facilityCoid = 'facilityCoid',
  keywordExact = 'keywordExact',
  keywords = 'keywords',
  locationUrlTitle = 'locationUrlTitle',
  locationUrlTitleLabel = 'locationUrlTitleLabel',
  specialtyId = 'specialtyId',
  specialtyName = 'specialtyName',
  specialty = 'specialty',
}

export const LISTING_FILTERS_STORAGE_KEY = 'oas_listing_filters';

export const DEFAULT_LANGUAGE = 'English';

export const ALL_FACILITY_OPTION = {
  coid: '001',
  locationUrlTitle: '',
  facilityName: 'All facility',
};

export const DEFAULT_SORT_BY = 'select below';
export const DISTANCE_SORT_BY = 'Distance';

export const NUMBER_DAYS_OUT = 62;
export const ITEMS_PER_PAGE = 10;
export const PAYLOAD_SOURCE = 'sitecore';
export const TODAY_DATE = generateTodayDate();
export const PAYLOAD_RANDOMIZE = true;
export const RANDOMIZER_SEED = `${new Date().toISOString()}-${Math.random()
  .toString(36)
  .substring(2, 8)}`; // randomized unique id

export const DEFAULT_REQ_PAYLOAD: ListingRequest = {
  coids: '',
  program: '',
  siteType: '',
  numberDaysOut: NUMBER_DAYS_OUT,
  meta: {
    page: 1,
    pageSize: ITEMS_PER_PAGE,
  },
  source: PAYLOAD_SOURCE,
  randomize: PAYLOAD_RANDOMIZE,
  randomizerSeed: RANDOMIZER_SEED,
  startDate: TODAY_DATE,
  latitude: null,
  longitude: null,
  sortType: null,
  gender: null,
  keywordExact: null,
  locationUrlTitle: null,
  specialtyId: null,
  languages: DEFAULT_LANGUAGE,
  teleMedicineFlg: false,
  showAcceptingNewPatientsOnly: false,
  facilityCoid: null,
  zip: '',
};

export const DEFAULT_LOCATION_FILTER = {
  address: '',
  zip: '',
  latitude: null,
  longitude: null,
};
